import type { Observable as ObservableType } from 'rxjs/Observable';
import type { hydrateJqlQuery$variables as HydrateJqlVariables } from '@atlassian/jira-relay/src/__generated__/hydrateJqlQuery.graphql.ts';
import { hydrateJqlBuilderQuery } from '../../rest/hydrate-jql-query/index.tsx';
import type { HydratedValues } from '../../rest/hydrate-jql-query/types.tsx';

export const fetchFieldValues = ({
	cloudId,
	jql,
}: HydrateJqlVariables): ObservableType<HydratedValues> => hydrateJqlBuilderQuery({ cloudId, jql });
